/**
 * Типы и константы сервиса уведомлений.
 */

export const NOTIFICATION_TYPES = ["success", "error", "info", "warning"] as const;

/** Тип уведомления. */
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

/** Длительность показа toast. */
export type NotificationDuration = number | "infinite";

/** Опции показа уведомления. */
export interface NotificationOptions {
    /** Идентификатор источника (для группировки/отладки). */
    fromId?: string;
    /** Длительность в мс или `"infinite"`. */
    duration?: NotificationDuration;
}

/** Payload для добавления в стор. */
export type NotificationPayload = {
    message: string;
    type: NotificationType;
} & NotificationOptions;

/** Запись уведомления в сторе. */
export interface NotificationData {
    id: string;
    message: string;
    type: NotificationType;
    timestamp: number;
    duration: NotificationDuration;
    fromId?: string;
    /** Для анимации появления. */
    open: boolean;
}
